import { defineStore } from "pinia";
import { useForm } from "@/form";

export const useStore = defineStore("pricingPlans", {
    state: () => {
        return {
            isLoadedData: false,
            productsData: [],
        };
    },

    getters: {
        products: (state) => {
            return state.productsData;
        },
        isLoaded: (state) => {
            return state.isLoadedData;
        },
    },

    actions: {
        async fetch() {
            try {
                this.productsData = await useForm().post("pricing_plans_index");
                this.isLoadedData = true;
            } catch (error) {
                return error;
            }
        },
    },
});
